var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.99225 0 0 8.99225 0 20C0 31.0078 8.99225 40 20 40C31.0078 40 40 31.0078 40 20C40 8.99225 31.0078 0 20 0ZM20 38.7597C9.6124 38.7597 1.24031 30.3876 1.24031 20C1.24031 9.6124 9.6124 1.24031 20 1.24031C30.3876 1.24031 38.7597 9.6124 38.7597 20C38.7597 30.3876 30.3876 38.7597 20 38.7597Z",
    fill: "#808285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3023 24.4961C28.9922 24.4961 28.6821 24.8062 28.6821 25.1162V27.5969H11.1627V25.1162C11.1627 24.8062 10.8527 24.4961 10.5426 24.4961C10.2325 24.4961 9.92242 24.8062 9.92242 25.1162V27.9069C9.92242 28.3721 10.3875 28.8372 10.8527 28.8372H28.9922C29.4573 28.8372 29.9224 28.3721 29.9224 27.9069V25.1162C29.9224 24.8062 29.6123 24.4961 29.3023 24.4961Z",
    fill: "#808285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5348 24.961C19.6899 25.116 19.8449 25.116 19.9999 25.116C20.155 25.116 20.31 25.116 20.4651 24.961L25.7364 19.6897C25.8914 19.5346 25.8914 19.0695 25.7364 18.9145C25.5813 18.7594 25.1162 18.7594 24.9612 18.9145L20.6201 23.2556V8.83695C20.6201 8.52687 20.31 8.2168 19.9999 8.2168C19.6899 8.2168 19.3798 8.52687 19.3798 8.83695V23.1005L14.8837 18.7594C14.7286 18.6044 14.2635 18.6044 14.1085 18.7594C13.9534 18.9145 13.9534 19.3796 14.1085 19.5346L19.5348 24.961Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportAssetIcon);
export default __webpack_public_path__ + "static/media/ImportAssetIcon.0d31d5c48f6c3e94e25c2e0a36448eb4.svg";
export { ForwardRef as ReactComponent };